import cx from "classnames";
import parse from "html-react-parser";

// Components
import Section from "../../../components/Section/SectionContainer";
// CSS

import styles from "../conference.module.scss";
/**
 * Constants
 */

 export const ConferenceNews = (props) => {
     const { conference } = props;
     const { conference_news } = conference || {};


    /**
     * Hooks
     */

    return (
        <Section
            classes={cx(styles.newsContainer, {
                [styles["newsContainer--hidden"]]: !conference_news,
            })}
        >
          <h1>symphony news</h1>

            <div className={styles.news}>
                {conference_news && <span>{parse(conference.conference_news)}</span>}
            </div>

        </Section>
    );
};
